import { useEffect } from 'react';

/**
 * Hook para prevenir el pull-to-refresh en dispositivos móviles
 * Previene específicamente la interferencia con la manipulación de gráficas
 */
export const usePreventPullToRefresh = () => {
  useEffect(() => {
    let startY = 0;
    
    // Función para manejar el inicio del touch
    const handleTouchStart = (e) => {
      startY = e.touches[0].clientY;
    };

    // Función para prevenir el pull-to-refresh
    const handleTouchMove = (e) => {
      const currentY = e.touches[0].clientY;
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      
      // Si estamos en la parte superior y el usuario arrastra hacia abajo
      if (scrollTop <= 0 && currentY > startY) {
        // Prevenir el comportamiento por defecto (pull-to-refresh)
        e.preventDefault();
      }
    };

    // Función para manejar touchmove en elementos específicos de gráficas
    const handleGraphTouchMove = (e) => {
      // Permitir movimiento para gráficas pero prevenir pull-to-refresh
      const target = e.target;
      const isGraphElement = target.closest('.recharts-wrapper') || 
                            target.closest('.recharts-surface') ||
                            target.closest('.recharts-cartesian-grid') ||
                            target.closest('.recharts-line') ||
                            target.closest('.recharts-area') ||
                            target.closest('.chart-container');
      
      if (isGraphElement) {
        // Para elementos de gráficas, permitir manipulación pero prevenir refresh
        e.stopPropagation();
      }
    };

    // Agregar listeners solo en dispositivos móviles
    const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent) || 
                     window.innerWidth <= 768;

    if (isMobile) {
      // Listeners para prevenir pull-to-refresh general
      document.addEventListener('touchstart', handleTouchStart, { passive: false });
      document.addEventListener('touchmove', handleTouchMove, { passive: false });
      
      // Listener específico para elementos de gráficas
      document.addEventListener('touchmove', handleGraphTouchMove, { passive: false });

      // Prevenir el comportamiento por defecto en casos específicos
      const preventDefaultTouch = (e) => {
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
        if (scrollTop <= 0) {
          e.preventDefault();
        }
      };

      // Agregar metaviewport si no existe
      const viewport = document.querySelector('meta[name="viewport"]');
      if (viewport) {
        viewport.setAttribute('content', 'width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no, viewport-fit=cover');
      }
    }

    // Cleanup
    return () => {
      if (isMobile) {
        document.removeEventListener('touchstart', handleTouchStart);
        document.removeEventListener('touchmove', handleTouchMove);
        document.removeEventListener('touchmove', handleGraphTouchMove);
      }
    };
  }, []);
};

export default usePreventPullToRefresh;